import { ConversationsAction } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import { Dispatch } from "react";
import { ResultRecord, StringUtils } from "@rsm-hcd/javascript-core";
import MessageFeedbackService, {
    UpdateMessageFeedbackPathParams,
    UpdateMessagePatchParams,
} from "utilities/services/conversations/message-feedback-service";
import ConversationMessageFeedbackRecord from "models/view-models/conversations/conversation-message-feedback-record";

export const updateMessageRating =
    (feedback: ConversationMessageFeedbackRecord) =>
    async (dispatch: Dispatch<ConversationsAction>) => {
        let result: ResultRecord<boolean> | undefined;

        try {
            if (!feedback.feedbackId) {
                dispatch({
                    type: "ERROR",
                    error: new Error(
                        "Cannot update feedback: Feedback ID is required for updates. Use createMessageRating for new feedback."
                    ),
                });
                return;
            }
            if (
                StringUtils.isEmpty(feedback.messageId) ||
                StringUtils.isEmpty(feedback.conversationId) ||
                StringUtils.isEmpty(feedback.feedbackId)
            ) {
                dispatch({
                    type: "ERROR",
                    error: new Error(
                        "Message ID, Conversation ID and Feedback ID are required to update a message."
                    ),
                });
                return;
            }

            const updateMessageFeedbackPathParams: UpdateMessageFeedbackPathParams =
                {
                    conversationId: feedback.conversationId,
                    messageId: feedback.messageId,
                    feedbackId: feedback.feedbackId,
                };

            const patchData: UpdateMessagePatchParams = {
                feedbackCategory: feedback.feedbackCategory
                    ? feedback.feedbackCategory
                    : undefined,
                feedbackComment: feedback.feedbackComment
                    ? feedback.feedbackComment
                    : undefined,
                rating: feedback.rating,
            };

            await MessageFeedbackService.updateFeedbackRating(
                updateMessageFeedbackPathParams,
                patchData
            );

            dispatch({
                type: "UPDATE_MESSAGE_FEEDBACK",
                feedback,
            });

            return;
        } catch (error) {
            result = new ResultRecord<boolean>().addError("ERROR", `${error}`);
            dispatch({
                type: "ERROR",
                error: new Error(
                    (
                        result?.listErrorMessages() || [
                            "Failed to update conversation",
                        ]
                    ).join(", ")
                ),
            });

            return;
        }
    };
